import { log } from 'log';
import { MutableRefObject, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { validateGeolocation } from 'js/hooks/auth/pas';
import { useSmartClosePopups } from 'js/components/common/PopupManager';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

import { showGeofencingPopupAction } from '../actions';
import * as constants from '../constants';

export const useReceivePacket = ({
    triggerGeolocation,
    setShowOverlay,
    useTransparentPopup,
    geolocationType,
    triggerTimestampRef
}: {
    triggerGeolocation: CallableFunction;
    setShowOverlay: (showOverlay: boolean) => void;
    useTransparentPopup: boolean;
    geolocationType: string;
    triggerTimestampRef: MutableRefObject<number | null>;
}) => {
    const dispatch = useDispatch();
    const onRefresh = useCallback(() => window.location.reload(), []);
    const closePopups = useSmartClosePopups();

    return useCallback(async (geoPacket: string, transactionID: string | null) => {
        const time = Date.now() - (triggerTimestampRef.current ?? 0);

        publicEventsAPIService.trigger('geofencing-response', { transactionID, time });

        log('gcRes', {
            transactionID,
            geoPacket
        });

        try {
            const response = await validateGeolocation(null, null, geoPacket, transactionID, null, geolocationType);

            if (response.data.errorCode === 0) {
                // all good
                setShowOverlay(false);
            }
        } catch (response: any) {
            publicEventsAPIService.trigger('geofencing-error', { response });

            switch (response.data.errorCode) {
                case 109:
                    // do nothing here, just try again
                    break;
                case 105:
                    // location is not allowed
                    setShowOverlay(false);
                    dispatch(showGeofencingPopupAction({
                        title: 'playtech.mobile.system.geocomply.popups.notAllowed.title',
                        content: response.data.playerMessage,
                        isModal: true,
                        buttons: [
                            {
                                onClick: () => closePopups(),
                                text: 'playtech.mobile.system.geocomply.popups.error.ignore',
                                color: 'negative'
                            },
                            {
                                onClick: onRefresh,
                                text: 'playtech.mobile.system.geocomply.popups.error.refresh',
                                color: 'info'
                            }
                        ],
                        useTransparentPopup
                    }));

                    // do not continue with geolocation
                    return;
                default:
                // noop
            }
        }

        await triggerGeolocation({
            reason: constants.GEOLOCATION_REASON.INTERVAL_CHECK
        });
    }, [
        closePopups,
        onRefresh,
        dispatch,
        triggerGeolocation,
        setShowOverlay,
        useTransparentPopup,
        geolocationType,
        triggerTimestampRef
    ]);
};
